module.exports = __webpack_public_path__ + "static/media/57.5c7ed99f.jpg";